/// <amd-module name="typeahead/core/plugins/DefaultPluginAssembly" />
/// <amd-dependency path="jquery" name="$" />

/// <reference path="../../../typings/typeahead/plugins.d.ts" />
/// <reference path="../../../typings/typeahead/browser.d.ts" />

export class DefaultPluginAssembly implements IPluginAssembly {

    public static requestParamModifierIdentifier: IPluginIdentifier = (plugin: any): boolean => {
        return "modifyParameters" in plugin;
    }

    public static suggestionsModifierIdentifier: IPluginIdentifier = (plugin: any): boolean => {
        return "modifySuggestions" in plugin;
    }

    public static dropDownHideHandler: IPluginIdentifier = (plugin: any): boolean => {
        return _.isFunction(plugin.handleDropDownHide);
    }

    public static dropDownShowHandler: IPluginIdentifier = (plugin: any): boolean => {
        return _.isFunction(plugin.handleDropDownShow);
    }

    public static dropdownContentHandler: IPluginIdentifier = (plugin: any): boolean => {
        return _.isFunction(plugin.handleContentToShow);
    }

    public static onFocusSuggestionsProviderIdentifier: IPluginIdentifier = (plugin: any): boolean => {
        return _.isFunction(plugin.suggestOnFocus);
    }

    public static pageLoadHandlerIdentifier: IPluginIdentifier = (plugin: any): boolean => {
        return _.isFunction(plugin.handlePageLoad);
    }

    public static experimentIdentifier: IPluginIdentifier = (plugin: any): boolean => {
        return _.isFunction(plugin.getExperiments);
    }

    private plugins: Object[] = [];

    public registerPlugin(plugin: Object) {
        addPluginToList(this.plugins, plugin);
    }

    public get(identifier: IPluginIdentifier): any[] {
        return this.plugins.filter((plugin) => {
            return identifier(plugin);
        });
    }
}

// internal scope, these should not be exposed to the outside world
function addPluginToList(utaPluginList: Object[], utaPlugin: Object) {
    if (utaPluginList.indexOf(utaPlugin) < 0) {
        utaPluginList.push(utaPlugin);
    }
}
